import React, { FC } from 'react';

import { Box, HStack } from '@chakra-ui/react';
import find from 'lodash/find';
import { customTheme } from 'theme';

import { FilterLabelWrapper } from 'components/DataDisplay/Box/BorderedBox/FilterLabelWrapper';
import { Select } from 'components/DataEntry';
import { SearchBox } from 'components/DataEntry/Input/SearchBox';

import { FilterOption, groupPrivilegeOptions } from './utils';

// A line above every option group but the first, and no group headings: the
// privilege menu's groups only separate combined choices from single levels.
const dividedGroupStyles = {
  group: base => ({
    ...base,
    borderTop: `1px solid ${customTheme.colors.gray['100']}`,
    '&:first-of-type': { borderTop: 'none' },
  }),
  groupHeading: () => ({ display: 'none' }),
};

interface PrincipalsToolbarProps {
  search: string;
  typeOptions: FilterOption[];
  principalType: string;
  privilegeOptions: FilterOption[];
  privilege: string;

  onSearchChange(value: string): void;

  onSearch(): void;

  onTypeChange(value: string): void;

  onPrivilegeChange(value: string): void;
}

/**
 * Search by name, and filter by principal type and privilege. Laid out like
 * the toolbar of the identity Permissions tab; the server applies all three.
 */
export const PrincipalsToolbar: FC<PrincipalsToolbarProps> = props => {
  const {
    search,
    typeOptions,
    principalType,
    privilegeOptions,
    privilege,
    onSearchChange,
    onSearch,
    onTypeChange,
    onPrivilegeChange,
  } = props;

  return (
    <HStack spacing={2}>
      <Box w={72}>
        <SearchBox
          value={search}
          onChange={onSearchChange}
          onSearch={onSearch}
          placeholder="Search principal"
          showShortcut={false}
        />
      </Box>
      <HStack>
        <FilterLabelWrapper>FILTER BY</FilterLabelWrapper>
        <Box minW={44}>
          <Select
            options={typeOptions}
            value={find(typeOptions, { value: principalType })}
            onChange={option => onTypeChange(option?.value ?? '')}
            showIconInValueContainer
            menuPortalTarget={document.body}
          />
        </Box>
        <Box minW={56}>
          <Select
            options={groupPrivilegeOptions(privilegeOptions)}
            value={find(privilegeOptions, { value: privilege })}
            onChange={option => onPrivilegeChange(option?.value ?? '')}
            styles={dividedGroupStyles}
            showIconInValueContainer
            menuPortalTarget={document.body}
          />
        </Box>
      </HStack>
    </HStack>
  );
};
